<template>
  <div class="modal fade" id="helpSearch" tabindex="-1" role="dialog"  aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="color-line"></div>
        <div class="modal-header">
          <h4 class="modal-title">Research assistance</h4>
        </div>
        <div class="modal-body">

          <div class="row" v-if="querySuggested" style="margin-top: 25px">
            <h5 class="text-center" >Would you like to try this spelling: </h5>
            <div class="col-xs-offset-2 col-xs-8" style="margin-top: 15px">

              <div class="input-group">
                <div class="bootstrap-tagsinput" style="width: 100%">
                  <template v-for="(keyword, key) in querySuggested">
                    <span :key="key" class="tag btn-outline btn btn-default" style="border-radius: 4px;">{{ keyword.trim() }}</span>
                  </template>
                </div>
                <div class="input-group-btn">
                  <vue-ladda type="button" :loading="false" class="btn btn-info" style="padding: 6px 28px" data-style="zoom-in" @click="newSearch('spelling')">
                    <i class="fa fa-2x fa-search"></i>
                  </vue-ladda>
                </div>
              </div>
            </div>
          </div>

          <div class="row" style="margin-top: 40px" v-if="queryExpanded">
            <h5 class="text-center">Would you like to try this query instead :</h5>
            <div class="col-xs-offset-2 col-xs-8" style="margin-top: 15px">

              <div class="input-group">
                <div class="bootstrap-tagsinput" style="width: 100%">
                  <template v-for="(keyword, key) in queryExpanded">
                    <span :key="key" class="tag btn-outline btn btn-default" style="border-radius: 4px;">{{keyword}}</span>
                  </template>
                </div>
                <div class="input-group-btn">
                  <vue-ladda type="button" :loading="false" class="btn btn-info" style="padding: 6px 28px" data-style="zoom-in" @click="newSearch('expanded')">
                    <i class="fa fa-2x fa-search"></i>
                  </vue-ladda>
                </div>
              </div>
            </div>
          </div>

          <div class="row" style="margin-top: 40px" v-if="queryExpanded && searchByName">
            <h5 class="text-center">If you are looking for somebody, you can try this query instead :</h5>

            <div class="col-xs-offset-2 col-xs-8" style="margin-top: 15px">
              <div class="input-group">

                <div class="bootstrap-tagsinput" style="width: 100%">
                  <span class="tag btn-outline btn btn-default" style="border-radius: 4px;">name:"{{queryExpanded.join(' ')}}"</span>
                </div>
                <div class="input-group-btn ">
                  <vue-ladda type="button" :loading="false" class="btn btn-info" style="padding: 6px 28px" data-style="zoom-in" @click="newSearch('name')">
                    <i class="fa fa-2x fa-search"></i>
                  </vue-ladda>
                </div>
              </div>

            </div>
          </div>

          <div class="text-center" style="margin-top: 25px">
            <span style="font-style: italic;font-size: 12px">You can launch new search from the assistance</span>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
        </div>

      </div>
    </div>
  </div>
</template>
<style>
  .input-group .bootstrap-tagsinput .tag {
    padding: 5px 15px;
    margin: 1px;
    color: #6a6c6f;
    border-radius: 4px;
  }
</style>
<script>
import VueLadda from 'vue-ladda'
import {cleanQueryFromTagsinputToSearch} from '../../assets/scripts/search'

export default {
  name: 'ResearchAssistance',
  props: ['query'],
  components: {
    VueLadda
  },
  data () {
    return {
      queryExpanded: null,
      querySuggested: null,
      searchByName: false,
      modalOpened: false
    }
  },
  watch: {
    queryExpanded: function (value) {
      if (value !== null && this.modalOpened === false) {
        $('#helpSearch').modal('show')
        this.modalOpened = true
      }
    },
    querySuggested: function (value) {
      if (value !== null && this.modalOpened === false) {
        $('#helpSearch').modal('show')
        this.modalOpened = true
      }
    },
    searchByName: function (value) {
      if (value !== false && this.modalOpened === false) {
        $('#helpSearch').modal('show')
        this.modalOpened = true
      }
    }
  },
  methods: {
    expandQuery: function (value) {
      if (value === null) {
        return null
      }

      let queryArray = value.trim('"').replace(/\s/g, ',').toLowerCase().split(',')

      queryArray = Object.fromEntries(queryArray.map(s => [s.toLowerCase(), s]))

      return Object.values(queryArray)
    },
    newSearch: function (type) {
      $('#helpSearch').modal('hide')

      switch (type) {
        case 'spelling':
          this.$emit('updateQuery', this.querySuggested.join(','))
          break
        case 'expanded':
          this.$emit('updateQuery', this.queryExpanded.join(','))
          break
        case 'name':
          this.$emit('updateQuery', 'name:"' + this.queryExpanded.join(' ') + '"')
          break
      }
    }
  },
  mounted () {
    this.querySuggested = null
    this.queryExpanded = this.expandQuery(this.query)

    let query = cleanQueryFromTagsinputToSearch(this.query)

    this.axios.get('/search/' + query + '/spellingSuggestion')
      .then((response) => {
        let suggestion = response.data

        if (suggestion.length !== 0 && suggestion !== query) {
          this.querySuggested = suggestion.replace(/"/g, '').trim().split(/(AND|OR|NOT)/gm)

          setTimeout(() => {
            $('.tag').map(function (key, tag) {
              tag = $(tag)
              let text = $(tag).text().trim()
              if (text === 'AND' || text === 'OR' || text === 'NOT') {
                tag.removeClass('btn-outline btn btn-default')
                tag.addClass('logic-word')
              }
            })
          }, 500)
        }
      })
      .catch(function (error) {
      })

    // if (this.queryExpanded.length <= 3) {
    //   this.searchByName = true
    // }

    let sameQuery = JSON.stringify(this.query.toLowerCase().split(',')) === JSON.stringify(this.queryExpanded)

    if (sameQuery === true) {
      this.queryExpanded = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/search/ResearchAssistance.vue